import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BecareService } from 'src/app/services/becare.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
              private becare: BecareService) {
    this.becare.authStatus().subscribe(status => {
      if (status === false) {
        console.log('LOGIN PANEL');
        this.redirectToLogin();
      }
    });
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      if (typeof(params.bearer) !== 'undefined' && typeof(params.userid) !== 'undefined') {
        localStorage.setItem('becare-logged-userid', params.userid);
        localStorage.setItem('becare-logged-bearer', params.bearer);
      }
      this.becare.autoAuthenticate().subscribe(user => {
        console.log('auto authenticated', user);
        this.router.navigate(['/']);
      }, error => {
        console.log('not authenticated ... open login panel');
        // Open Login panel
        console.log('Opening login panel');
        // this.openLoginPanel();
      });
    });
  }

  redirectToLogin() {
    console.log('LOGIN PANEL');
    // Redirect to login url
    window.location.href = window.location.protocol + '//sso.' + window.location.host;
  }
}
